import { cn } from "@/app/utils/cn"
import { useTheme } from "@/app/hooks/useTheme"
import { OptionType } from "@/app/utils/optionSelectType"
import { BasicSelect } from "@/view/components/BasicSelect"
import { CSSObjectWithLabel } from "react-select"

interface SelectProps {
  name: string
  label: string
  options: OptionType[]
  labelIcon?: React.ReactNode
  placeholder: string
  error?: string
}
export const Select = ({ name, label, options, placeholder, labelIcon, error }: SelectProps) => {
  const { theme } = useTheme()
  const isDark = theme === "dark"

  const palette = {
    border: "darkgray",
    text: isDark ? "#ffffff" : "#0C0E13",
    placeholder: isDark ? "#9CA3AF" : "#6B7280",
    controlBg: isDark ? "hsl(222.2 84% 4.9%)" : "transparent",
    menuBg: isDark ? "hsl(222.2 84% 4.9%)" : "#ffffff",
    optionHoverBg: isDark ? "#1F2937" : "#F3F4F6",
    optionSelectedBg: isDark ? "#374151" : "#E5E7EB",
  }

  return (
    <div className="">
      <BasicSelect
        classNameLabel={cn("text-gray-700 font-semibold text-left flex flex-col items-right dark:text-gray-200", "[&_p]:hidden")}
        classNameContainer="h-auto"
        name={name}
        label={
          <div className="flex items-center ml-2">
            {labelIcon}
            <span className="text-gray-700 font-semibold text-left flex flex-col items-right dark:text-gray-200">{label}</span>
          </div>
        }
        options={options as OptionType[]}
        placeholder={placeholder}
        styles={{
          control: (base: CSSObjectWithLabel) => ({
            ...base,
            minHeight: '40px',
            borderRadius: '12px',
            border: `1px solid ${palette.border} !important`,
            boxShadow: 'none',
            backgroundColor: palette.controlBg,
          }),
          placeholder: (base: CSSObjectWithLabel) => ({
            ...base,
            color: palette.placeholder,
          }),
          singleValue: (base: CSSObjectWithLabel) => ({
            ...base,
            color: palette.text,
          }),
          input: (base: CSSObjectWithLabel) => ({
            ...base,
            color: palette.text,
          }),
          menu: (base: CSSObjectWithLabel) => ({
            ...base,
            backgroundColor: palette.menuBg,
            color: palette.text,
            zIndex: 50,
          }),
          option: (base: CSSObjectWithLabel, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? palette.optionSelectedBg
              : state.isFocused
                ? palette.optionHoverBg
                : palette.menuBg,
            color: palette.text,
            cursor: 'pointer',
          }),
        }}
        hiddeError={true}
      />
      {error && (
        <div className="min-h-5 mt-1 text-left text-xs sm:text-sm text-error">{error}</div>
      )}
    </div>
  )
}